import Distance from './styled';

export default Distance;
